<app-header></app-header>

<div class="home-main">
  <div class="sidebar">
    <app-sidebar
      (headingEvent)="receiveHeading($event)"
      (toggleSidebarEvent)="receiveSidebarEvent($event)"
    />
  </div>

  <div class="discovery-updates" *ngIf="newsDetails">
    <div class="bg_1 p-x-40 p-y-17 dis_flex font_13 weight_600">
      <div
        class="dis_flex align_center color_blue cursor_pointer"
        [routerLink]="'/discovery-category/' + categoryId"
      >
        {{ matchedCategoryName }}
      </div>
      <div class="dis_flex align_center p-x-16">
        <svg
          width="7"
          height="8"
          viewBox="0 0 7 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
            fill="#303030"
          />
        </svg>
      </div>
      <div
        class="dis_flex align_center"
        style="
          max-width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        "
        [title]="newsDetails?.title"
      >
        {{ newsDetails?.title }}
      </div>
    </div>
    <div class="discovery-updates_body p-top-40 p-x-20">
      <div class="discovery-updates_body_left">
        <div class="color_blue font_12 weight_800">AGROCHEMICALS</div>
        <div class="color_black font_18 weight_600 p-top-8">
          {{ newsDetails.title }}
        </div>
        <div
          class="color_black font_14 weight_500 p-top-10"
          style="text-align: justify"
        >
          {{ newsDetails.summary }}
        </div>

        <div class="p-top-10 color_black font_12 weight_600">
          Written By:
          <span class="color_blue weight_800">{{
            newsDetails.reporter | uppercase
          }}</span
          ><span class="p-x-40">|</span>{{ newsDetails.news_date | date }}
        </div>
        <div class="share-buttons" style="margin-top: 15px">
          <button
            (click)="copyLink()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fas fa-link" style="color: #000"></i>
            <!-- Copy Link -->
          </button>
          <button
            (click)="shareViaEmail()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fas fa-envelope" style="color: #ea4335"></i>
            <!-- Email -->
          </button>
          <button
            (click)="shareViaSMS()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fas fa-sms" style="color: #25d366"></i>
            <!-- SMS -->
          </button>
          <button
            (click)="shareViaWhatsApp()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-whatsapp" style="color: #25d366"></i>
            <!-- WhatsApp -->
          </button>
          <button
            (click)="shareViaMessenger()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-facebook-messenger" style="color: #0084ff"></i>
            <!-- Messenger -->
          </button>
          <button
            (click)="shareViaViber()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-viber" style="color: #59267c"></i>
            <!-- Viber -->
          </button>
          <button
            (click)="shareViaFacebook()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-facebook" style="color: #4267b2"></i>
            <!-- Facebook -->
          </button>
          <button
            (click)="shareViaTwitter()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-twitter" style="color: #1da1f2"></i>
            <!-- Twitter -->
          </button>
          <button
            (click)="shareViaLinkedIn()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-linkedin" style="color: #0077b5"></i>
            <!-- LinkedIn -->
          </button>
          <button
            (click)="shareViaPinterest()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-pinterest" style="color: #e60023"></i>
            <!-- Pinterest -->
          </button>
          <button
            (click)="shareViaReddit()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-reddit" style="color: #ff4500"></i>
            <!-- Reddit -->
          </button>
          <button
            (click)="shareViaTumblr()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-tumblr" style="color: #35465c"></i>
            <!-- Tumblr -->
          </button>
          <button
            (click)="shareViaTelegram()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-telegram" style="color: #0088cc"></i>
            <!-- Telegram -->
          </button>
          <button
            (click)="shareViaVK()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-vk" style="color: #4b7be5"></i>
            <!-- VK -->
          </button>
          <button
            (click)="shareViaMix()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-mix" style="color: #00a3e0"></i>
            <!-- Mix -->
          </button>
          <button
            (click)="shareViaXing()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-xing" style="color: #006567"></i>
            <!-- Xing -->
          </button>
          <button
            (click)="shareViaLine()"
            style="background: transparent; border: none; cursor: pointer"
          >
            <i class="fab fa-line" style="color: #00b900"></i>
            <!-- Line -->
          </button>
        </div>
        <div class="p-b-30 p-top-30">
          <img
            [src]="filePath + newsDetails.thumbnailImage"
            alt="Thumbnail Image"
            loading="lazy"
            class="width_80_per height_80_per"
          />
        </div>
        <div
          class="p-top-24 width_100_per content-container quill-html"
          [innerHtml]="newsDetails.description"
        ></div>
      </div>

      <div class="discovery-updates_body_right p-x-20">
        <div>
          <div class="color_black font_20 weight_700 border_bottom_blue_1">
            <div class="p-bot-10 border_bottom_pink_5 width_fit">
              Sub Categories
            </div>
          </div>
          <div
            class="color_black font_16 weight_600"
            *ngIf="categoryList.length"
          >
            <ng-container *ngFor="let category of categoryList">
              <div
                class="dis_flex jc_space_bet p-top-16"
                [routerLink]="'/discovery-category/' + category._id"
                style="cursor: pointer"
              >
                {{ category.name }}
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.1117 5.99274L4.3265 0.207681C4.19269 0.0737718 4.01408 0 3.82362 0C3.63317 0 3.45455 0.0737718 3.32075 0.207681L2.89471 0.633613C2.61749 0.911155 2.61749 1.36224 2.89471 1.63936L7.75266 6.4973L2.88932 11.3606C2.75552 11.4945 2.68164 11.6731 2.68164 11.8634C2.68164 12.054 2.75552 12.2325 2.88932 12.3665L3.31536 12.7923C3.44927 12.9262 3.62778 13 3.81823 13C4.00869 13 4.1873 12.9262 4.32111 12.7923L10.1117 7.00198C10.2458 6.86764 10.3194 6.68829 10.319 6.49762C10.3194 6.30622 10.2458 6.12697 10.1117 5.99274Z"
                    fill="#0032A0"
                  />
                </svg>
              </div>
            </ng-container>
          </div>
          <div
            class="p-t-32 color_black font_20 weight_700 border_bottom_blue_1"
          >
            <div class="p-bot-10 border_bottom_pink_5 width_fit">
              Related News
            </div>
          </div>
          <ng-container *ngIf="relatedNews.length">
            <ng-container *ngFor="let news of relatedNews">
              <div
                class="p-top-16 dis_flex cursor_pointer"
                (click)="goToNewsDetail(news.slug || news._id)"
              >
                <img
                  class="width_120 aspect_ratio_1 border-radius-6"
                  [src]="filePath + news.thumbnailImage"
                />
                <div class="color_black p-l-25">
                  <div class="font_12 weight_500">
                    {{ news.news_date | date }}
                  </div>
                  <div class="p-top-8 font_16 weight_600">{{ news.title }}</div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="discovery-updates_right1 p-x-20">
      <div>
        <div class="color_black font_20 weight_700 border_bottom_blue_1">
          <div class="p-bot-10 border_bottom_pink_5 width_fit">
            Sub Categories
          </div>
        </div>
        <div class="color_black font_16 weight_600">
          <ng-container *ngFor="let category of categoryList">
            <div class="dis_flex jc_space_bet p-top-16">
              {{ category.name }}
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.1117 5.99274L4.3265 0.207681C4.19269 0.0737718 4.01408 0 3.82362 0C3.63317 0 3.45455 0.0737718 3.32075 0.207681L2.89471 0.633613C2.61749 0.911155 2.61749 1.36224 2.89471 1.63936L7.75266 6.4973L2.88932 11.3606C2.75552 11.4945 2.68164 11.6731 2.68164 11.8634C2.68164 12.054 2.75552 12.2325 2.88932 12.3665L3.31536 12.7923C3.44927 12.9262 3.62778 13 3.81823 13C4.00869 13 4.1873 12.9262 4.32111 12.7923L10.1117 7.00198C10.2458 6.86764 10.3194 6.68829 10.319 6.49762C10.3194 6.30622 10.2458 6.12697 10.1117 5.99274Z"
                  fill="#0032A0"
                />
              </svg>
            </div>
          </ng-container>
        </div>
        <div class="p-t-32 color_black font_20 weight_700 border_bottom_blue_1">
          <div class="p-bot-10 border_bottom_pink_5 width_fit">
            Related News
          </div>
        </div>
        <ng-container *ngIf="relatedNews.length">
          <ng-container *ngFor="let news of relatedNews">
            <div class="p-top-16 dis_flex cursor_pointer">
              <img
                class="width_120 aspect_ratio_1 border-radius-6"
                [src]="filePath + news.thumbnailImage"
              />
              <div class="color_black p-l-25">
                <div class="font_12 weight_500">
                  {{ news.news_date | date }}
                </div>
                <div class="p-top-8 font_16 weight_600">
                  <a
                    href="https://img.freepik.com/free-photo/digital-art-beautiful-mountains_23-2151123686.jpg"
                    target="_blank"
                    >{{ news.title }}</a
                  >
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
